import React, {useRef} from 'react';

import {useResizeObserver} from '../../hooks/useResizeObserver';
import {ObservedBox} from './styles';

type ElementResizeListenerProps = React.HTMLAttributes<HTMLDivElement> & {
  position?: 'absolute' | 'relative' | 'sticky';
  onResize?: (size: {width: number; height: number}) => void;
};

const ElementResizeListener = ({onResize, children, ...rest}: ElementResizeListenerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useResizeObserver(ref, onResize);

  return (
    <ObservedBox ref={ref} {...rest}>
      {children}
    </ObservedBox>
  );
};

export default ElementResizeListener;
